import React from "react";
import { TextField, FormGroup, Button, Grid } from "@material-ui/core";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const TierForm = props => {
  const {
    values,
    handleChange,
    index,
    handleBlur,
    touched,
    errors,
    handleDeleteTier
  } = props;
  const { t } = useTranslation();

  return (
    <div>
      <Grid container spacing={24}>
        <Grid item xs={10}>
          <h5>{t("add_kid.tiers_info.title")} - {Number(index) + 1}</h5>
        </Grid>
        <Grid item xs={2}>
          <Button color="primary" onClick={() => handleDeleteTier(index)}>
            {t("common.delete")}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.tiers_info.nom")}
              name={`tierceAutorisesDto[${index}][nom]`}
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span>
                  {touched.tierceAutorisesDto &&
                    touched.tierceAutorisesDto[index] &&
                    touched.tierceAutorisesDto[index]["nom"] &&
                    errors.tierceAutorisesDto &&
                    errors.tierceAutorisesDto[index] &&
                    errors.tierceAutorisesDto[index]["nom"]}
                </span>
              }
              value={values.tierceAutorisesDto[index]["nom"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.tiers_info.prenom")}
              name={`tierceAutorisesDto[${index}][prenom]`}
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span>
                  {touched.tierceAutorisesDto &&
                    touched.tierceAutorisesDto[index] &&
                    touched.tierceAutorisesDto[index]["prenom"] &&
                    errors.tierceAutorisesDto &&
                    errors.tierceAutorisesDto[index] &&
                    errors.tierceAutorisesDto[index]["prenom"]}
                </span>
              }
              value={values[`tiers${index}lastName`]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.tiers_info.telephone")}
              type="number"
              variant="outlined"
              name={`tierceAutorisesDto[${index}][numeroTel]`}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span>
                  {touched.tierceAutorisesDto &&
                    touched.tierceAutorisesDto[index] &&
                    touched.tierceAutorisesDto[index]["numeroTel"] &&
                    errors.tierceAutorisesDto &&
                    errors.tierceAutorisesDto[index] &&
                    errors.tierceAutorisesDto[index]["numeroTel"]}
                </span>
              }
              value={values.tierceAutorisesDto[index]["numeroTel"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.tiers_info.lien_parente")}
              variant="outlined"
              name={`tierceAutorisesDto[${index}][lienDeParente]`}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span>
                  {touched.tierceAutorisesDto &&
                    touched.tierceAutorisesDto[index] &&
                    touched.tierceAutorisesDto[index]["lienDeParente"] &&
                    errors.tierceAutorisesDto &&
                    errors.tierceAutorisesDto[index] &&
                    errors.tierceAutorisesDto[index]["lienDeParente"]}
                </span>
              }
              value={values.tierceAutorisesDto[index]["lienDeParente"]}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </div>
  );
};

TierForm.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  handleDeleteTier: PropTypes.func,
  touched: PropTypes.object,
  style: PropTypes.object
};

export default TierForm;
